module.exports = __webpack_public_path__ + "img/video_1.29cfc084.gif";